 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"home":"home","explain":"explain","feedback":"feedback","switch":"switch","transfer":"transfer"}[chunkId]||chunkId) + "." + {"chunk-03f67894":"568a2291","chunk-24570e6f":"b254fa1d","chunk-282dddb7":"177a69c4","chunk-2b318400":"e96a448d","chunk-2d44f521":"6a53a0a0","chunk-2f6dc55f":"c77998cb","chunk-3f7104b2":"1046c726","chunk-3f9fda56":"36d73c81","chunk-4420f726":"f4728df8","chunk-46c69f14":"5b126645","chunk-4fd47936":"c9cc3b78","chunk-505e405d":"d44f298b","chunk-521dd0c4":"31dc94e5","chunk-58049e04":"d4b704df","chunk-5a10cbaa":"1f056731","chunk-5b3da5fe":"e5871de3","chunk-5b58015d":"2f3d4bf7","chunk-5cc4816b":"e5a721aa","chunk-5fe79acd":"b322b786","chunk-6af2fad5":"7676fbd9","chunk-45750dc8":"eadce3e0","chunk-7535fe1e":"175953fa","chunk-48004ea2":"81b6f0d9","chunk-6fac3796":"7b875606","chunk-7092ab14":"0cccdab0","chunk-7d7ca3c0":"d3724d2e","chunk-7dc7271f":"2aa8b05d","chunk-7de3003d":"8e3e4775","chunk-913fd0fa":"da269363","chunk-9ebfcaf6":"fa059224","chunk-bd589d8e":"d8d3c6af","chunk-6e714126":"9b6ded98","chunk-c88acd54":"f0f6993d","chunk-e982a3b8":"4d0afe57","chunk-02abb509":"d093393c","chunk-2cec1c0d":"5edb5414","chunk-3c7dacae":"9bff168b","home":"5e068d4e","chunk-ff886034":"8e1b4dac","explain":"53d7a5fc","feedback":"de3de6ae","switch":"18ea3973","transfer":"c6be41c0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-03f67894":1,"chunk-24570e6f":1,"chunk-282dddb7":1,"chunk-2b318400":1,"chunk-2d44f521":1,"chunk-2f6dc55f":1,"chunk-3f7104b2":1,"chunk-3f9fda56":1,"chunk-4420f726":1,"chunk-46c69f14":1,"chunk-4fd47936":1,"chunk-505e405d":1,"chunk-521dd0c4":1,"chunk-58049e04":1,"chunk-5a10cbaa":1,"chunk-5b3da5fe":1,"chunk-5b58015d":1,"chunk-5cc4816b":1,"chunk-5fe79acd":1,"chunk-45750dc8":1,"chunk-7535fe1e":1,"chunk-48004ea2":1,"chunk-6fac3796":1,"chunk-7092ab14":1,"chunk-7d7ca3c0":1,"chunk-7dc7271f":1,"chunk-7de3003d":1,"chunk-913fd0fa":1,"chunk-9ebfcaf6":1,"chunk-6e714126":1,"chunk-c88acd54":1,"chunk-02abb509":1,"chunk-2cec1c0d":1,"chunk-3c7dacae":1,"home":1,"chunk-ff886034":1,"explain":1,"feedback":1,"switch":1,"transfer":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"home":"home","explain":"explain","feedback":"feedback","switch":"switch","transfer":"transfer"}[chunkId]||chunkId) + "." + {"chunk-03f67894":"1cef58f0","chunk-24570e6f":"37ff60f9","chunk-282dddb7":"f597b205","chunk-2b318400":"7818753b","chunk-2d44f521":"9bfaa5e5","chunk-2f6dc55f":"d51ed8d5","chunk-3f7104b2":"a08a03c8","chunk-3f9fda56":"74962d2e","chunk-4420f726":"a95b0211","chunk-46c69f14":"f849a043","chunk-4fd47936":"ec842070","chunk-505e405d":"cadd741c","chunk-521dd0c4":"4b48453b","chunk-58049e04":"1785f97d","chunk-5a10cbaa":"62ba4f24","chunk-5b3da5fe":"670a3a6a","chunk-5b58015d":"feaa4eb4","chunk-5cc4816b":"a403aeaf","chunk-5fe79acd":"7edc5edd","chunk-6af2fad5":"31d6cfe0","chunk-45750dc8":"200b3358","chunk-7535fe1e":"62753cc1","chunk-48004ea2":"7f4dcd5f","chunk-6fac3796":"a68a008b","chunk-7092ab14":"36664981","chunk-7d7ca3c0":"7267f6e2","chunk-7dc7271f":"6b29c4b7","chunk-7de3003d":"7e6e96c1","chunk-913fd0fa":"4ee0a514","chunk-9ebfcaf6":"c14d5603","chunk-bd589d8e":"31d6cfe0","chunk-6e714126":"f784edc6","chunk-c88acd54":"5ff17bfd","chunk-e982a3b8":"31d6cfe0","chunk-02abb509":"8c5efc78","chunk-2cec1c0d":"c74b529d","chunk-3c7dacae":"49e9038c","home":"ff9b58e2","chunk-ff886034":"0fbde389","explain":"365f7849","feedback":"a02a5a26","switch":"81e26fe2","transfer":"13fabcb2"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
